import { WebAppUser } from 'src/types/web-app-users';
import { axiosInstance, endpoints } from 'src/utils/axios';

interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user?: WebAppUser;
}

interface LoginData {
  email: string;
  password: string;
  host: string;
}

export const authRepository = {
  async login(data: LoginData): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.webapp.auth.login, data);

    if (!response.data) {
      throw new Error('Login failed');
    }

    return response.data;
  },

  async refreshAccessToken(refreshToken: string): Promise<string> {
    const response = await axiosInstance.post(endpoints.webapp.auth.refresh, { refreshToken });

    if (!response.data?.accessToken) {
      throw new Error('Failed to refresh access token');
    }

    return response.data.accessToken;
  },

  async logout(refreshToken: string): Promise<AuthResponse> {
    const response = await axiosInstance.post(endpoints.webapp.auth.logout, { refreshToken });

    if (!response.data) {
      throw new Error('Logout failed');
    }

    return response.data;
  },
};
